import Image from 'next/image'

const subindicatorIconMappings = {
  'Keteraturan Suasana Kelas': 'img-chalk-board-teach-character-stundet.png',
  'Penerapan Disiplin Positif': 'img-flow-process.png',
  'Ekspektasi pada Peserta Didik': 'img-book-rapor-graphic.png',
  'Perhatian dan Kepedulian': 'img-heart-empathic-give.png',
  'Umpan Balik Konstruktif': 'img-chat-talk.png',
  'Aktivitas Interaktif': 'img-curation-cards-screen.png',
  'Instruksi yang Adaptif': 'img-assessment-subject-book.png',
  'Instruksi Pembelajaran': 'img-chalk-board.png',
}

export function PraktikPembelajarIcon({
  subindicator,
}: {
  subindicator: string
}) {
  const fileName =
    subindicatorIconMappings[subindicator] ??
    'img-chalk-board-teach-character-stundet.png'

  return (
    <div className="w-[84px] h-[84px] relative">
      {/* Prevent user select */}
      <div className="absolute inset-0 z-10">&nbsp;</div>

      <Image
        alt=""
        src={['/illustrations', fileName].join('/')}
        width={84}
        height={84}
      />
    </div>
  )
}
